import { Card, Typography, Tag, Space } from "antd";
import { DownOutlined } from "@ant-design/icons";

const { Text } = Typography;

export default function PriceCard() {
    return (
        <Card
            style={{
                width: 340,
                background: "#121212",
                borderRadius: 12,
                border: "1px solid #1f1f1f",
            }}
            bodyStyle={{ padding: 16 }}
        >
            {/* TOP ROW */}
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Space size={6}>
                    <Text style={{ color: "#e5e7eb", fontWeight: 600 }}>EURUSD</Text>
                    <DownOutlined style={{ color: "#9ca3af", fontSize: 12 }} />
                </Space>

                <Tag color="green" style={{ margin: 0 }}>
                    +0.00%
                </Tag>
            </div>

            {/* PRICE SECTION */}
            <div style={{ marginTop: 12 }}>
                <Text style={{ color: "#9ca3af", fontSize: 12 }}>Price</Text>

                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <Text
                        style={{
                            fontSize: 28,
                            fontWeight: 700,
                            color: "#ffffff",
                        }}
                    >
                        1.1703
                    </Text>

                    <div style={{ textAlign: "right" }}>
                        <Text style={{ color: "#9ca3af", fontSize: 12 }}>Spread</Text>
                        <br />
                        <Text style={{ color: "#e5e7eb" }}>0.0002</Text>
                    </div>
                </div>
            </div>

            {/* BOTTOM INFO */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginTop: 12,
                }}
            >
                <Text style={{ color: "#9ca3af", fontSize: 12 }}>
                    Mark: <span style={{ color: "#e5e7eb" }}>1.1703</span>
                </Text>

                <Text style={{ color: "#9ca3af", fontSize: 12 }}>
                    Index: <span style={{ color: "#e5e7eb" }}>1.1703</span>
                </Text>
            </div>
        </Card>
    );
}
